import React from 'react';
import type { HeaderBlockSlice } from '../../../../types';
import * as S from './styles';

type Props = Pick<HeaderBlockSlice, 'title'>;

const HeaderBlock = ({ title }: Props) => {
  return (
    <S.Header>
      <S.Title>{title}</S.Title>
    </S.Header>
  );
};

export default HeaderBlock;
